import axios from 'axios'
import { notificationSuccess, notificationDanger } from '../../../utils/customToastify'

import {
  GET_DIVISION,
  GET_ALL_DIVISIONS,
  UPDATE_DIVISION,
  DELETE_DIVISION,
  CREATE_DIVISION,
  RESET_DIVISION,
  GET_DIVISIONS_FOR_SELECT,
} from './types'

import { GET_ERRORS } from '../../../actions/types'
export const getDivision = (divisionId) => async (dispatch) => {
  try {
    const response = await axios.get(`/divisions/${divisionId}`)
    dispatch({
      type: GET_DIVISION,
      payload: response.data,
    })
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    throw new Error(error)
  }
}

export const getAllDivisions = (options) => async (dispatch) => {
  try {
    const response = await axios.get('/divisions', { params: { ...options } })
    dispatch({
      type: GET_ALL_DIVISIONS,
      payload: response.data,
    })
  } catch (error) {
    throw new Error(error)
  }
}

export const getDivisionsForCustomSelect = () => async (dispatch) => {
  const response = await axios('/divisions/for-select')
  dispatch({
    type: GET_DIVISIONS_FOR_SELECT,
    payload: response.data,
  })
}

export const updateDivision = (divisionId, data) => async (dispatch) => {
  try {
    const response = await axios.patch(`/divisions/${divisionId}`, data)
    dispatch({
      type: UPDATE_DIVISION,
      payload: response.data,
    })
    notificationSuccess(`Division > ${response.data.name} < Changed Successifully.`)
    return response
  } catch (error) {
    dispatch({
      type: GET_ERRORS,
      payload: error.response.data,
    })
  }
}

export const createDivision = (data) => async (dispatch) => {
  const response = await axios.post(`/divisions`, data)
  dispatch({
    type: CREATE_DIVISION,
    payload: response.data,
  })
  return response
}

export const deleteDivision = (divisionId, data) => async (dispatch) => {
  try {
    const response = await axios.delete(`/divisions/${divisionId}`, data)
    dispatch({
      type: DELETE_DIVISION,
    })
    if (response.status === 200) {
      notificationDanger('You just deleted Division!')
    } else {
      notificationDanger('This division is related with other division or user, you cannot delete it')
    }
    return response
  } catch (error) {
    throw new Error(error)
  }
}

export const resetDivision = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_DIVISION,
      payload: {},
    })
  } catch (error) {
    throw new Error(error)
  }
}
